import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'

import { contractQueries } from '@/entities/contract'

type Props = {
  roomId: number
}

export const useLastActiveContract = ({ roomId }: Props) => {
  const { data, refetch } = useQuery({
    ...contractQueries.lastActiveContract({ roomId }),
    enabled: false,
  })

  const fetchLastActiveContract = useCallback(async () => {
    const data = await refetch()

    return {
      success: !data.isError,
      data: data.data?.lastActiveContract || null,
    }
  }, [refetch])

  return {
    lastActiveContract: data?.lastActiveContract,
    fetchLastActiveContract,
  }
}
